import React, {useState} from 'react';

import SelectWithCheckbox from '../../../CoreWrappers/SelectWithCheckbox';

const SelectCheckDrydock = () => {
	const [value, setValue] = useState(null);

	const props = {
		options: [
			{
				label: 'Sarasa A',
				options: [
					{value: 1, label: 'option 1'},
					{value: 2, label: 'option 2'},
					{value: 3, label: 'option 3'},
					{value: 4, label: 'option 4'}
				]
			},
			{
				label: 'Sarasa B',
				options: [
					{value: 5, label: 'option 5'},
					{value: 6, label: 'option 6'},
					{value: 7, label: 'option 7'}
				]
			},
			{
				label: 'Sarasa C',
				options: [
					{value: 8, label: 'option 8'},
					{value: 9, label: 'option 9'}
				]
			}
		],
		onChange: (newValue) => setValue(newValue),
		value,
		label: 'Form Label DD',
		labels: {
			allSelected: 'All selected DD',
			multiSelect: '{0} selected DD',
			nonSelected: 'empty DD'
		}
	};

	return <SelectWithCheckbox {...props} />;
};

export default SelectCheckDrydock;
